import React, {useEffect, useState} from "react";
import {Button, Modal, Tab, Tabs} from "react-bootstrap";
import {TabAccountComponent} from "./tab-account.component";
import {TabOrgComponent} from "./tab-org.component";
import {getListOrgByAccountId} from "../../../api-service/account";

export default function ModalSettingsComponent({show, onClose, item}) {
    const [tabActive, setTabActive] = useState<any>("account");
    const [accountDetail, setAccountDetail] = useState<any>(null);

    const handleClose = () => {
        setTabActive("account");
        setAccountDetail(null);
        onClose();
    };

    useEffect(() => {
        if (item){
            const getListOrgs = async () => {
                await getListOrgByAccountId(item?.AccountId).then((response: any) => {
                    setAccountDetail(response);
                })
            }
            getListOrgs();
        }

    }, [item]);

    const refreshData = async () => {
        await getListOrgByAccountId(item?.AccountId).then((response: any) => {
            setAccountDetail(response);
        })
    }

    return (
        <Modal className="modal-admin-settings pt-5" size={"lg"} show={show} onHide={handleClose}>
            <Modal.Header closeButton>
                取引先・組織設定
            </Modal.Header>
            <Modal.Body className="p-5">
                {
                    accountDetail && <Tabs
                        defaultActiveKey="account"
                        activeKey={tabActive}
                        onSelect={(k) => setTabActive(k)}
                        className="tab-header"
                    >
                        <Tab eventKey="account" title="取引先設定">
                            <TabAccountComponent accountInfo={accountDetail}
                            onSubmit={refreshData}
                            />

                        </Tab>
                        <Tab eventKey="org" title="組織設定">
                            <TabOrgComponent
                                onSubmit={refreshData}
                                accountInfo={accountDetail} orgSelected={item.OrgId}/>
                        </Tab>
                    </Tabs>
                }

            </Modal.Body>
            <Modal.Footer className="modal-footer">
                <Button variant="light" size="sm" className="modal-btn modal-cancel-btn" onClick={handleClose}>
                    閉じる
                </Button>
            </Modal.Footer>
        </Modal>
    );
}
